<template>
    <Head>
        <title>Адреса</title>
    </Head>

    <authenticated-layout>

        <template #header>
            <organization-navigation  v-if="organizationId" :organization-id="organizationId"/>
        </template>

        <div class="flex flex-col bg-white">

            <div class="flex flex-row px-6 py-2 gap-2">
                <form method="post" action="#" class="flex flex-row items-end gap-2" @submit.prevent="paginate(1)">
                    <div class="w-80">
                        <v-input label="Адрес" type="search" v-model="search"/>
                    </div>
                    <div class="flex flex-col text-sm">
                        <div class="flex flex-row gap-2">
                            <input type="checkbox" name="withDeleted" id="withDeleted" v-model="withDeleted"/>
                            <label for="withDeleted">Показывать удаленные</label>
                        </div>
                        <div class="flex flex-row gap-2">
                            <input type="checkbox" name="withoutEmptyBalance" id="withoutEmptyBalance" v-model="withoutEmptyBalance"/>
                            <label for="withoutEmptyBalance">Скрыть нулевые балансы</label>
                        </div>
                    </div>
                    <v-button>Поиск</v-button>
                </form>
            </div>

            <div v-if="success"
                 :class="!organizationId ? 'grid-cols-11' : 'grid-cols-9'"
                 class="grid px-6 py-2 gap-x-2 items-end text-sm font-bold">
                <span class="col-span-2 row-span-2" v-if="!organizationId">Владелец</span>
                <span class="col-span-3 row-span-2">Id, Адрес</span>
                <select
                    class="row-span-2 text-sm font-bold border-0 p-0"
                    :class="{ 'text-blue-700': risk !== null}"
                    @change="paginate(1)"
                    v-model="risk"
                >
                    <option :value="null">Риск</option>
                    <option value="unchecked">Не проверен</option>
                    <option value="white">Нет</option>
                    <option value="green">Низкий</option>
                    <option value="yellow">Средний</option>
                    <option value="red">Высокий</option>
                    <option value="black">Недопустимый</option>
                </select>
                <select
                    class="row-span-2 text-sm font-bold border-0 p-0"
                    :class="{ 'text-blue-700': type !== null}"
                    @change="paginate(1)"
                    v-model="type"
                >
                    <option :value="null">Тип</option>
                    <option value="PAY_IN">PAY_IN</option>
                    <option value="PAY_OUT">PAY_OUT</option>
                    <option value="BUSINESS">BUSINESS</option>
                    <option value="SPENDER">SPENDER</option>
                    <option value="RECURRENT">RECURRENT</option>
                    <option value="PERSONAL">PERSONAL</option>
                    <option value="REFERRAL">REFERRAL</option>
                    <option value="COLLECT">COLLECT</option>
                </select>
                <select
                    class="row-span-2 text-sm font-bold border-0 p-0"
                    :class="{ 'text-blue-700': currencyId !== null}"
                    @change="paginate(1)"
                    v-model="currencyId"
                >
                    <option :value="null">Валюта</option>
                    <option v-for="(name, id) in currencies" :value="id">{{ name }}</option>
                </select>
                <select
                    class="row-span-2 text-sm font-bold border-0 p-0"
                    :class="{ 'text-blue-700': networkId !== null}"
                    @change="paginate(1)"
                    v-model="networkId"
                >
                    <option :value="null">Сеть</option>
                    <option v-for="(name, id) in networks" :value="id">{{ name }}</option>
                </select>
                <span class="col-span-2">Баланс</span>
                <span>пользовательский</span>
                <span>блокчейна</span>
            </div>

            <div v-if="success" v-for="row in rows"
                 class="grid border-t px-6 py-2 gap-2 items-center text-sm"
                 :class="{
                     'text-gray-500': !row.active,
                     'grid-cols-11': !organizationId,
                     'grid-cols-9': !!organizationId,
                 }">
                <span class="col-span-2" v-if="!organizationId">
                    <Link class="text-blue-700" v-if="row.owner.id" :href="route('organization', row.owner.id)">{{ row.owner.name }}</Link>
                    <span v-else>{{ row.owner }}</span>
                </span>
                <div class="flex flex-col col-span-3">
                    <span class="text-gray-500">{{ row.id }}</span>
                    <span>{{ row.address }}</span>
                </div>
                <div class="flex flex-row gap-2">
                    <svg v-if="access('addresses', 'check')"
                         @click="checkRisk(row)"
                         :class="awaitRisk ? 'cursor-not-allowed animate-spin': 'cursor-pointer hover:text-green-500'"
                         class="h-4 w-4 text-gray-500 cursor-pointer"
                         viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="23 4 23 10 17 10" />
                            <polyline points="1 20 1 14 7 14" />
                            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
                    </svg>
                    <span>{{ row.risk }}</span>
                </div>
                <span>{{ row.type }}</span>
                <span>{{ row.currency }}</span>
                <span>{{ row.network }}</span>
                <span>{{ row.balance.user }}</span>
                <span>{{ blockchainBalance[row.address]  ||  '???' }}</span>
            </div>

            <v-pagination
                class="p-6"
                :count="total"
                :page="page"
                :limit="limit"
                :paginate="paginate"
            />

        </div>


    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VInput from "@/Components/Input";
import VButton from "@/Components/Button";
import VPagination from "@/Components/PaginationOffset";
import OrganizationNavigation from "@/Components/Navigation/Organization.vue";

export default {
    components: {
        OrganizationNavigation,
        Head, Link,
        AuthenticatedLayout,
        VInput,
        VButton,
        VPagination,
    },
    props: {
        notifications: Array,
        currencies: Object,
        networks: Object,
        organizationId: String,
        limit: Number,
        page: Number,
        withDeleted: Boolean,
        withoutEmptyBalance: Boolean,
        search: String,
        currencyId: null|String,
        networkId: null|String,
        risk: null|String,
        type: null|String,
        success: Boolean,
        total: Number,
        rows: Object,
    },
    data() {
        return {
            awaitRisk: false,
            blockchainBalance: {},
        }
    },
    methods: {
        paginate(page) {
            const { organizationId, withDeleted, withoutEmptyBalance, currencyId, networkId, search, risk, type } = this;

            useForm({ page, withDeleted, withoutEmptyBalance, currencyId, networkId, search, risk, type })
                .get(organizationId  ? this.route('organization.addresses', organizationId) : this.route('addresses'));
        },
        async checkRisk(row) {
            if(this.awaitRisk) return;

            this.awaitRisk = true;

            const {owner, address} = row;
            const organization = !this.organizationId ? owner.id : this.organizationId;

            const res = await axios.get(this.route('organization.address.check', {organization, address}))
                .then(response => response.data);

            if(res.risk)
                row.risk = res.risk;

            this.awaitRisk = false;
        },
    },
    mounted() {
        const addresses = [];
        for (const row of this.rows) {
            const {address, currency, network} = row;
            if(!currency ||  !network) continue;
            addresses.push({ address, coin: currency, network });
        }
        axios.post(this.route('addresses.blockchain-balance'), {addresses})
            .then(res => this.blockchainBalance = res.data.result);
    },
}
</script>
